import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'components/ui/button';

import SparkBadge from './spark_badge';

// TODO: Replace with dynamic starters
const STARTERS = [
  {
    label: 'Find a contact',
    sub: 'Search your contacts by name or company',
    prompt: 'Help me find a contact',
  },
  {
    label: 'Look up contact details',
    sub: 'Pull up everything on one of your contacts',
    prompt: 'Look up the details for one of my contacts',
  },
];

interface Props {
  onSelect: (prompt: string) => void;
}

export default function ConversationStarters({ onSelect }: Props) {
  return (
    <div className="d-flex gap-2 mb-3">
      <SparkBadge className="flex-shrink-0 align-self-start" />
      <div className="d-flex flex-column gap-3 flex-grow-1">
        <strong>So, what are we running?</strong>
        {STARTERS.map(starter => (
          <Button
            className="ai-assistant-starter d-flex align-items-center gap-2 p-2 text-start text-body"
            key={starter.label}
            variant="outline"
            onClick={() => onSelect(starter.prompt)}
          >
            <SparkBadge className="flex-shrink-0" />
            <span className="flex-grow-1">
              <span className="d-block fw-semibold">{starter.label}</span>
              <span className="d-block text-muted small">{starter.sub}</span>
            </span>
            <FontAwesomeIcon className="text-muted flex-shrink-0" icon={faArrowRight} />
          </Button>
        ))}
        <p className="text-muted small text-center mb-0">Or just type the job in the bar below.</p>
      </div>
    </div>
  );
}
